import { render, staticRenderFns } from "./SettingHrFeed.vue?vue&type=template&id=5a61497c&scoped=true"
import script from "./SettingHrFeed.vue?vue&type=script&lang=js"
export * from "./SettingHrFeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a61497c",
  null
  
)

export default component.exports